import React, { useContext } from 'react';
import Sidebar from '../Layout/Sidebar/index';
import Header from '../Layout/Header/index';
import Footer from '../Layout/Footer';
import { SidebarProvider, SidebarContext } from '../Layout/SidebarContext';

const ContentWrapper = ({ children }) => {
  const { isExpanded, isMobile } = useContext(SidebarContext);
  
  return (
    <div className="flex flex-col min-h-screen relative" style={{ 
      marginLeft: isMobile ? '0' : (isExpanded ? '200px' : '70px'),
      width: isMobile ? '100%' : `calc(100% - ${isExpanded ? '200px' : '70px'})`,
      transition: 'all 0.3s ease',
      paddingTop: '64px', // Add padding for fixed header
      paddingBottom: '60px' // Add padding for fixed footer
    }}>
      <div className="fixed top-0 left-0 right-0 z-50" style={{
        marginLeft: isMobile ? '0' : (isExpanded ? '200px' : '70px'),
        transition: 'all 0.3s ease'
      }}>
        <Header />
      </div>
      <main className="flex-1 flex flex-col w-full">
        {children}
      </main>
      <div className="fixed bottom-0 left-0 right-0" style={{
        marginLeft: isMobile ? '0' : (isExpanded ? '200px' : '70px'),
        transition: 'all 0.3s ease'
      }}>
        <Footer />
      </div>
    </div>
  );
};

const Hoc = (BaseComponent) => {
  return function EnhancedComponent(props) {
    return (
      <SidebarProvider>
        <div className="flex bg-white min-h-screen w-full">
          <Sidebar />
          <ContentWrapper>
            <BaseComponent {...props} />
          </ContentWrapper>
        </div>
      </SidebarProvider>
    );
  };
};

export default Hoc